import SectionCard from "./common/SectionCard";
import StatisticCard from "./StatisticCard";
import { getLang } from "../../../store/uiStore";

export default function ReportingSection({ data }) {
    const lang = getLang();
    const tr = {
        section: lang === "ru" ? "Исполнение отчетности" : "Иҷрои ҳисоботдиҳӣ",
        accepted: lang === "ru" ? "Сдали отчет" : "Ҳисобот супориданд",
        notSubmitted: lang === "ru" ? "Не сдали отчет" : "Ҳисобот насупориданд",
        late: lang === "ru" ? "Просрочено" : "Муҳлат гузаштааст",
        returned: lang === "ru" ? "На доработке" : "Барои ислоҳ баргардонида шуд",
    };

    if (!data) {
        return null;
    }

    return (

       <SectionCard

           title={tr.section}

           icon="clipboard-check"

       >

            <div className="row g-3">

                <div className="col-lg-3 col-md-6">

                    <StatisticCard
                        title={tr.accepted}
                        value={data.accepted.count}
                        subtitle={`${data.accepted.percent}%`}
                        color="success"
                    />

                </div>

                <div className="col-lg-3 col-md-6">

                    <StatisticCard
                        title={tr.notSubmitted}
                        value={data.not_submitted.count}
                        subtitle={`${data.not_submitted.percent}%`}
                        color="warning"
                    />

                </div>

                <div className="col-lg-3 col-md-6">

                    <StatisticCard
                        title={tr.late}
                        value={data.late.count}
                        subtitle={`${data.late.percent}%`}
                        color="danger"
                    />

                </div>

                <div className="col-lg-3 col-md-6">

                    <StatisticCard
                        title={tr.returned}
                        value={data.returned.count}
                        subtitle={`${data.returned.percent}%`}
                        color="info"
                    />

                </div>

            </div>

        </SectionCard>

    );

}
